
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-customer-service-2-line',
      title: 'IT Helpdesk & Support',
      description: 'Round-the-clock technical assistance for your team. We resolve issues fast so your business never skips a beat.',
      price: '$100'
    },
    {
      icon: 'ri-router-line',
      title: 'Network Setup & Management',
      description: 'Professional network infrastructure design and ongoing management to ensure reliable, secure connectivity.',
      price: '$150'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cybersecurity Audit & Protection',
      description: 'Comprehensive security assessments and protection strategies to safeguard your data from evolving threats.',
      price: '$200'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Hosting & Migration',
      description: 'Seamless cloud transitions with optimized performance, scalability, and cost-efficiency for your applications.',
      price: '$250'
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-slate-900 to-indigo-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block px-4 py-2 bg-violet-500/20 border border-violet-500/30 text-violet-300 text-xs sm:text-sm font-semibold rounded-full mb-4">
            What We Offer
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">IT Services That Scale</h2>
          <p className="text-base sm:text-lg text-gray-400 max-w-3xl mx-auto px-4">
            Choose from our range of professional IT services designed to support businesses of all sizes. Flexible, reliable, and affordable.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-slate-800/50 backdrop-blur-sm border-l-4 border-violet-500 rounded-xl p-6 sm:p-8 hover:bg-slate-800 transition-all duration-300 hover:shadow-xl hover:shadow-violet-500/20 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-12 sm:w-14 h-12 sm:h-14 flex items-center justify-center bg-gradient-to-br from-violet-600 to-purple-600 rounded-xl mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-white text-xl sm:text-2xl`}></i>
              </div>
              <div className="mb-3">
                <span className="text-xl sm:text-2xl font-bold text-violet-400">{service.price}</span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3">{service.title}</h3>
              <p className="text-sm text-gray-400 mb-4 sm:mb-6 leading-relaxed">{service.description}</p>
              <Link 
                to="/services"
                className="text-sm font-semibold text-violet-400 hover:text-violet-300 flex items-center space-x-2 group-hover:translate-x-2 transition-transform whitespace-nowrap cursor-pointer"
              >
                <span>View Details</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:mt-12">
          <Link 
            to="/services"
            className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-violet-600 text-white font-semibold rounded-lg hover:bg-violet-700 transition-all shadow-lg hover:shadow-violet-500/50 whitespace-nowrap cursor-pointer"
          >
            View All 7 Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
